import { customizeProductPages } from './landingPages'
import { getBrandImagePresentation } from './brandScenes'
import googleMerchant from './googleMerchant.json'

const config = {
  customizeProductPages,
  pageBuilderImagePresentation: getBrandImagePresentation,
  hideAiGeneratedBadges: true,
  spaciousBrandCarousels: true,
  productStickyPurchase: true,
  cartVariant: 'modern',
  mobileMenuVariant: 'modern',
  checkoutVariant: 'modern',
  compactCheckoutFooter: true,
  footerMobileAccordions: true,
  customerProject: {
    key: 'homeylove',
    shopIds: [101],
    template: 'www.homeylove.de',
  },

  deliveryCountries: ['DE'],

  googleMerchant,

  // Template-Elemente
  productLagerwareTopAlert: true,
  stockDeliveryTime: 3,
  couponDisplay:true,
  VorkasseDisplay:true,
  NachnahmeDisplay:false,
  RechnungDisplay:false,
  PayPalAdvancedCardsDisplay:true,
  PayPalGooglePayDisplay:true,
  // Apple Pay ist aktuell nur mit paypal@homeylove.de nutzbar.
  // Bei info@homeylove.de auf false lassen; bei paypal@homeylove.de wieder true setzen.
  PayPalApplePayDisplay:false,
  PayPalPayLaterDisplay:true,

  // Strukturierte Daten: Standardwerte je Shop vor Launch pruefen.
  structuredData: {
    returns: {
      merchantReturnDays: 14,
      returnFees: 'https://schema.org/ReturnFeesCustomerResponsibility',
      returnMethod: 'https://schema.org/ReturnByMail',
      refundType: 'https://schema.org/FullRefund',
      applicableCountries: ['DE'],
      returnPolicyCountry: 'DE',
    },
    shipping: {
      destinationCountry: 'DE',
      handlingTime: { minValue: 0, maxValue: 1, unitCode: 'DAY' },
      shippingTypes: {
        1: { name: 'Warenpost', rate: 'deutschland' },
        10: { name: 'Paket-Versand', rate: 'deutschland' },
        12: { name: 'Paket-Versand Sperrgut', rate: 'deutschland' },
        20: { name: 'Speditions-Versand', rate: 'spedition' },
        30: { name: 'Speditions-Versand Sperrgut', rate: 'spedition' },
      },
      defaultShippingType: 10,
    },
  },

  pageBuilderDefaults: {
    layout: {
      stylePreset: 'westwing', navigationPosition: 'top', navigationDisplay: 'inline',
      heroMobileMode: 'fullscreen', contentWidth: 'full', magazinePlacement: 'hidden',
      hideLegacyHeader: true, showCategorySliderArrows: true,
    },
    theme: {
      fontFamily: '"DM Sans", Arial, sans-serif',
      backgroundColor: '#ffffff', surfaceColor: '#fff4e9', textColor: '#102d59', mutedTextColor: '#465570',
      accentColor: '#ff7a1a', accentContrastColor: '#102d59',
      buttonBackgroundColor: '#ff7a1a', buttonHoverColor: '#f16c0c', buttonTextColor: '#102d59',
      purchaseButtonBackgroundColor: '#ff7a1a', purchaseButtonHoverColor: '#f16c0c', purchaseButtonTextColor: '#102d59',
      navigationBackgroundColor: '#ffffff', navigationTextColor: '#102d59', navigationOverlayOpacity: 22,
      infoColor: '#335fc5', successColor: '#1f7a4d', warningColor: '#b7791f', errorColor: '#b8463f',
    },
    products: { columnsPerRow: 4, columnsPerRowMobile: 2 },
  },

  headerLogo: {
    builderMaxWidth: 255, builderMaxHeight: 51, builderInlineMaxWidth: 270,
    builderMobileMaxWidth: 'clamp(168px, 54vw, 248px)', builderMobileMaxHeight: 62,
  },

  productImageViewer: { variant: 'fullscreen' },

  productPreview: {
    mobileStyle: 'editorial',
  },

  // PayPal
  paypal: {
    live: {
      //für info@homeylove.de:
      "client-id": 'Aa4vq3TNbFEXQPdVY0SuBYsV6L92as8nuFKlKtCDqNUZwRlLgJSmxCQoSVkycKwYQC85ytZuVTd12eyK',
      
      //für paypal@homeylove.de:
      //"client-id": 'AXFT046jeEqRBMjCrm_0ChBrOlGx5OMF2tX5U_lbZyxIqr6SUVlHibk_Ov2Hdor7bQop9G3dLbHNUYDj',
    },
    dev: {
      "client-id": 'AXNo2j0t33R20Sdp5bu9ZzbMsyVMSpLoxqPozCky0t6GRRmo3YbCA3PPpFmmKNzMMDD1amQ96etxkoDA',
      //"data-client-token": "abc123xyz==",
    },
  },

  // Footer
  // Die globale Standard-"Über uns"-Seite enthält Designmöbelkaufen-Inhalte.
  showAboutPageLink: false,
  brands: [

    36,  // Joop!
    39,  // Cawoe
    166, // Greengate
    183, // Aquanova
    209, // Möve
    210, // Bloomingville

    //42,  // Bassetti
    //34,  // Formesse
    //160, // The Laundress
    //189, // Bondi Wash

    //203, // Meraki
    //201, // Claus Porto
    //190, // Björk & Berries
    //196, // Le Jacquard Francais
    
  ]

} as const

export default config
